import { SET_REFERRER_PRODUCT } from '../productList/productListConstants';
import { TOGGLE_VIEW } from './toggleViewConstants';

export const isGridView = (state = false, action) => {
  switch (action.type) {
    case SET_REFERRER_PRODUCT:
      return action.isGridView;
    case TOGGLE_VIEW:
      return !state;
    default:
      return state;
  }
};
